import AppVersionGuard from './AppVersionGuard';

export default AppVersionGuard;
